import {ADMIN_ROUTE_CONSTANTS} from '@shared/constants/routes';
import {MenuItem} from 'primeng/api';

const adminBase = `/${ADMIN_ROUTE_CONSTANTS.path}`;

export const OPERATIONS: MenuItem = {
  label: ADMIN_ROUTE_CONSTANTS.operations.data.breadcrumb,
  icon: ADMIN_ROUTE_CONSTANTS.operations.data.icon,
  hasSubmenu: true,
  expanded: false,
  items: [
    {
      label: ADMIN_ROUTE_CONSTANTS.operations.maintenance.data.breadcrumb,
      icon: ADMIN_ROUTE_CONSTANTS.operations.maintenance.data.icon,
      routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.operations.path}/${ADMIN_ROUTE_CONSTANTS.operations.maintenance.path}`
    },
    {
      label: ADMIN_ROUTE_CONSTANTS.operations.repairHistory.data.breadcrumb,
      icon: ADMIN_ROUTE_CONSTANTS.operations.repairHistory.data.icon,
      routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.operations.path}/${ADMIN_ROUTE_CONSTANTS.operations.repairHistory.path}`
    },
    {
      label: 'MENU_ADMIN.OPERATIONS_SUB.CALENDAR',
      icon: 'pi pi-calendar',
      hasSubmenu: true,
      expanded: false,
      items: [
        {
          label: ADMIN_ROUTE_CONSTANTS.operations.reservations.data.breadcrumb,
          icon: ADMIN_ROUTE_CONSTANTS.operations.reservations.data.icon,
          routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.operations.path}/${ADMIN_ROUTE_CONSTANTS.operations.reservations.path}`
        }
      ]
    },
    {
      label: ADMIN_ROUTE_CONSTANTS.operations.inventory.data.breadcrumb,
      icon: ADMIN_ROUTE_CONSTANTS.operations.inventory.data.icon,
      routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.operations.path}/${ADMIN_ROUTE_CONSTANTS.operations.inventory.path}`
    },
    {
      label: ADMIN_ROUTE_CONSTANTS.operations.moving.data.breadcrumb,
      icon: ADMIN_ROUTE_CONSTANTS.operations.moving.data.icon,
      routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.operations.path}/${ADMIN_ROUTE_CONSTANTS.operations.moving.path}`
    }
  ]
};
